var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((this.data),function(listitem){return _c('li',{key:listitem,staticStyle:{"list-style-type":"none"}},[_vm._v(_vm._s(listitem))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }